import { useTranslation } from "@/i18n/client";
import { Box } from "@mantine/core";
import { Modal } from "@/components/Modal";
import ButtonsGroup from "@/components/ButtonsGroup";
import { ContextModalProps } from "@mantine/modals";
import { useSaveMutation } from "@/hooks/useSaveMutation";
import { useRouter } from "next/navigation";
import { getContractUrl } from "@/router";
import { SCREENS } from "@/router/screens";
import { useContractState } from "@/hooks/useContractState";
import { useIsContractRequest } from "@/hooks/useIsContractRequest";

const rightButtonProps = { type: "submit" } as const;

interface SopRequiredModalProps {
  uuid: string;
}

export const sopRequiredModalContext = {
  modal: "sopRequired",
  closeOnClickOutside: false,
  closeOnEscape: false,
  withCloseButton: false,
  innerProps: {},
};

export const SopRequiredModal = ({ context, id, innerProps }: ContextModalProps<SopRequiredModalProps>) => {
  const { t } = useTranslation("modals");

  const router = useRouter();
  const { contract, uuid } = useContractState();
  const isContractRequest = useIsContractRequest();

  const handleSubmit = () => {
    mutation.mutate({
      ...contract,
    });
  };
  const handleSuccess = () => router.push("https://www.eon.cz/");
  const redirect = () => {
    context.closeModal(id);
    router.replace(getContractUrl(uuid, SCREENS.GUIDE, isContractRequest));
  };
  const handleClose = () => context.closeModal(id);
  const mutation = useSaveMutation(uuid, handleSuccess, handleClose);

  return (
    <Box pos="relative">
      <Modal.LoadingOverlay isLoading={mutation.isPending} />
      <Modal.Title>{t("sopRequired.title")}</Modal.Title>
      <Modal.Description description={t("sopRequired.description")} />
      <ButtonsGroup
        leftButtonText={t("sopRequired.return")}
        rightButtonText={t("sopRequired.save")}
        onRightButtonClick={handleSubmit}
        onLeftButtonClick={redirect}
        rightButtonProps={rightButtonProps}
      />
    </Box>
  );
};
